import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import appLogo from '../../assets/logoFinal-removebg-preview.png';
import opening from "../../assets/openings.svg"
import { getCareerPageJobDetail } from '../services/operations/jobPostAPI';
import Loader from '../Loader/Loader';
import { FiArrowLeft } from "react-icons/fi";
import ApplyJob from './ApplyJob';

const EmbeddedJobView = () => {

    const [job, setJob] = useState([])
    const [showUpload,setShowUpload]=useState(false);
    const [loading, setLoading] = useState(false);
    const { id, company } = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate();


    const handleViewJob = async () => {
        setLoading(true);
        const response = await dispatch(getCareerPageJobDetail(id))
        if (response?.data?.job) {
            setJob(response.data.job)
        }
        setLoading(false);
    }

    useEffect(() => {
        handleViewJob()
    }, [])


    const skills = job.skills ? JSON.parse(job.skills) : [];
    const industries = job.industries ? JSON.parse(job.industries) : [];


    const handleApplyJob=()=>{

        setShowUpload(true);
    }



    return (
        <div className='career-page-container' style={{ minHeight: '100vh' }}>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <div className='career-page-navbar'>
                        <div className='career-page-company-detail'>
                            <p className='company-name-career-page'>
                                <img src={opening} alt='openings' />
                                <span>{company}</span>
                            </p>
                            <p className='career-page-opening'>Current Openings</p>
                        </div>
                    </div>

                    <div className='jobs-detailing-container'>
                        <div className='all-jobs-first'>
                            <div className='all-jobs-first-section-part'>
                                <button className="jobpost-back-button" onClick={() => navigate(-1)}>
                                    <FiArrowLeft style={{ marginRight: "5px" }} /> Back to Jobs
                                </button>
                                <button className='job-listing-apply-button save-apply-btn'  onClick={handleApplyJob}>Apply Job</button>
                            </div>
                            <p style={{ fontWeight: "600", fontSize: "20px" }}>{job.job_title}</p>
                            <p style={{ fontSize: "16px" }}>{job.company_name}</p>
                            <p style={{ color: " rgba(0, 0, 0, 0.5)", fontSize: "14px" }}>{job.job_location}</p>
                        </div>
                        <div className='jobpost-detail-first' style={{ marginTop: "15px" }}>
                            <p className='jobpost-detail-work-type'>{job?.workplace_type}</p>
                            <p className='jobpost-detail-work-type'>{job?.employment_type}</p>
                        </div>
                        <div style={{ marginTop: "20px", borderBottom: "0.5px solid rgba(0, 0, 0, 0.1)" }} />
                        <div className='jobpost-detail-second-section' style={{ padding: "25px 25px 25px 0px" }}>
                            <p style={{ fontWeight: "600", fontSize: "20px" }}>About the job</p>
                            <p
                                style={{
                                    all: "unset",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                    fontSize: "13px",
                                    fontWeight: "400",
                                    lineHeight: "1.5",
                                }}
                                dangerouslySetInnerHTML={{ __html: job.description }}
                            ></p>
                            <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Skills required</p>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {skills?.length > 0 && (
                                    skills.map((skill, index) => (
                                        <span
                                            key={index}
                                            style={{
                                                background: 'white',
                                                padding: '5px 10px',
                                                borderRadius: '20px',
                                                fontSize: '14px',
                                                border: "0.5px solid rgba(45, 118, 253, 1)",
                                                color: "rgba(45, 118, 253, 1)"
                                            }}
                                        >
                                            {skill}
                                        </span>
                                    )))}
                            </div>
                            <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Industries</p>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {industries?.length > 0 && (
                                    industries.map((industry, index) => (
                                        <span
                                            key={index}
                                            style={{
                                                background: 'white',
                                                padding: '5px 10px',
                                                borderRadius: '20px',
                                                fontSize: '14px',
                                                border: "0.5px solid rgba(45, 118, 253, 1)",
                                                color: "rgba(45, 118, 253, 1)"
                                            }}
                                        >
                                            {industry}
                                        </span>
                                    )))}
                            </div>
                            {job?.experience && (<>
                                <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Experience Required</p>
                                <p style={{ fontSize: "16px" }}>{job?.experience} Years</p></>)}

                            {job?.salary_range && (
                                <> <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Expected Salary</p>
                                    <p style={{ fontSize: "16px" }}>{job?.salary_range}</p>
                                </>
                            )}
                            {
                                job?.contract_price_per_hrs && (
                                    <>
                                        <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Contract Pay</p>
                                        <p style={{ fontSize: "16px" }}>${job?.contract_price_per_hrs}/hr</p>
                                    </>)
                            }
                        </div>

                    </div>
                    <div className='career-page-company-footer'>
                        <p className='career-page-opening' style={{ display: "flex", alignItems: "center" }}><span>Powered by</span><img src={appLogo} alt='app=logo' /></p>
                    </div>
                </>
            )}
            <ApplyJob  isOpen={showUpload} jobId={job?.id} onClose={()=>setShowUpload(false)}/>
        </div>
    );
}

export default EmbeddedJobView;
